import { Firebase } from './app';
import 'firebase/auth';

export default Firebase.auth();
